import React, { Component } from 'react';
import DeviceData from 'drivers/deviceData';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';
import EventBus from 'utils/eventBus';
import DefaultCities from 'components/weather/defaultCities';
import { getWeatherDetail, parseWeatherDetails } from 'components/main/common/utils';
import {
  WeatherDisplayContainer,
  CityName,
  WeatherInfoContainer,
  WeatherIconContainer,
  TemperatureDisplay,
  WeatherDetailsContainer,
  WeatherDetail,
} from 'components/styles/Weather.styled';

import LoadImage from 'components/common/loadImage/loadImage';
import { translate as t } from 'utils/i18n';

class BaseWeatherComponent extends Component {
  constructor(props) {
    super(props);

    this.state = Object.assign({}, this.state, {
      subscriptions: {},
      items: [],
      loading: false,
      redirectBack: false,
    });

    this.onKeyPress = this.onKeyPress.bind(this);
  }

  componentDidMount() {
    this.subscriptions = EventBus.subscribe('getWeather', this.getData.bind(this));
    window.addEventListener('keydown', this.onKeyPress);
    this.getData();
  }

  componentWillUnmount() {
    this.subscriptions?.unsubscribe();
    clearInterval(this.interval);
    window.removeEventListener('keydown', this.onKeyPress);
  }

  async onKeyPress(event) {
    const tvKeyControls = await DeviceData.getTVControl();

    if (event.keyCode === tvKeyControls.KEY_BACK) {
      this.setState({
        redirectBack: true,
      });
      event.preventDefault();
    }
  }

  async getData() {
    this.getWeatherDetailCurrentCity();
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.getWeatherDetailCurrentCity();
    }, 10000 * 6);
  }

  getWeatherDetailCurrentCity() {
    const lang = Storages.MainStorage.getItem(StorageKeys.Keys.LANGUAGECODE)?.split('_')[0] || 'en';
    const locations = Storages.MainStorage.getItem(StorageKeys.Keys.ORGANIZATIONLOCATIONS) || [];

    const locationArray = locations.map((location) => location?.city_name);

    if (locationArray.length === 0) {
      locationArray.push(DefaultCities.new_york, DefaultCities.london);
    }

    this.setState({ loading: true });

    Promise.all(locationArray.map((location) => getWeatherDetail(location, lang)))
      .then((weatherDataArray) => {
        var weatherDetails = weatherDataArray.map(function (weatherData, index) {
          return Object.assign(
            {},
            { id: index + 1, active: index === 0 },
            parseWeatherDetails(weatherData)
          );
        });

        this.setState({ items: weatherDetails, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false, items: null });
      });
  }

  renderWeatherData() {
    return this.state.items.map(
      (item, i) =>
        item != null && (
          <WeatherDisplayContainer key={i}>
            <CityName>{item.name}</CityName>
            <WeatherInfoContainer>
              <WeatherIconContainer>
                <LoadImage
                  image_url={'http://openweathermap.org/img/wn/' + item?.icon + '.png'}
                  width={'80px'}
                  height={'80px'}
                />
              </WeatherIconContainer>
              <TemperatureDisplay>
                {item.temp} {t('Weather.degreeCentigrade')}
              </TemperatureDisplay>
              <WeatherDetailsContainer>
                <WeatherDetail>
                  {t('Weather.humidity')}: {item.humidity}%
                </WeatherDetail>
                <WeatherDetail>
                  {t('Weather.wind')}: {item?.windSpeed} m/h
                </WeatherDetail>
              </WeatherDetailsContainer>
            </WeatherInfoContainer>
          </WeatherDisplayContainer>
        )
    );
  }
}

export default BaseWeatherComponent;
